/**
 * Spotlight Shortcut Hook
 * 
 * Sağ Shift'e 2 kere basıldığında Spotlight modal'ı açar
 * Global keyboard listener
 */

import { useEffect, useRef } from 'react';
import useAuthStore from '@/store/use-auth-store';
import { useSlashCommandStore } from '../store/slash-command-store';

export const useSpotlightShortcut = () => {
  const { isSpotlightOpen, openSpotlight, closeSpotlight } = useSlashCommandStore();
  const lastShiftPressRef = useRef<number>(0);
  const shiftPressCountRef = useRef<number>(0);
  
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Sağ Shift kontrolü (ShiftRight)
      if (e.key === 'Shift' && e.location === KeyboardEvent.DOM_KEY_LOCATION_RIGHT) {
        // Komutlar auth gerektirir; login/register gibi ekranlarda tetiklenmemeli.
        // getState ile okunur, böylece listener auth değişiminde yeniden kurulmaz.
        if (!useAuthStore.getState().isAuthenticated()) return;

        const now = Date.now();
        const timeSinceLastPress = now - lastShiftPressRef.current;
        
        // 500ms içinde 2. basış ise
        if (timeSinceLastPress < 500) {
          shiftPressCountRef.current += 1;
        } else {
          // Yeni basış serisi başladı
          shiftPressCountRef.current = 1;
        }
        
        lastShiftPressRef.current = now;
        
        // 2 kere basıldıysa Spotlight'ı aç
        if (shiftPressCountRef.current === 2) {
          e.preventDefault();
          if (!isSpotlightOpen) {
            openSpotlight();
          }
          shiftPressCountRef.current = 0; // Reset
        }
      } else {
        // Başka bir tuşa basıldıysa reset
        if (Date.now() - lastShiftPressRef.current > 500) {
          shiftPressCountRef.current = 0;
        }
      }
      
      // Escape ile Spotlight'ı kapat
      if (e.key === 'Escape' && isSpotlightOpen) {
        e.preventDefault();
        closeSpotlight();
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isSpotlightOpen, openSpotlight, closeSpotlight]);
};

